import type { Permissions } from '@/context/Permissions/Permissions.types';

import type { JudgeAccess, JudgeView, JudgeViewInput } from './JudgeDetail.types';

/** A new judge needs `create`; an existing one is shown to anyone who can read it. */
export const judgeView = ({
	isNew,
	canCreate,
	isLoadingPermissions,
	isLoadingJudge,
	hasJudge,
}: JudgeViewInput): JudgeView => {
	if (isNew) {
		if (isLoadingPermissions) return 'loading';
		return canCreate ? 'ready' : 'denied';
	}
	if (isLoadingJudge) return 'loading';
	return hasJudge ? 'ready' : 'notFound';
};

/** Editing an existing judge needs `update`; deleting it needs `delete`. */
export const judgeAccess = (isNew: boolean, permissions: Permissions): JudgeAccess => ({
	readOnly: !isNew && !permissions.update,
	canDelete: !isNew && permissions.delete,
});
